import React, { useState } from 'react';
import { TagIcon, MapPinIcon, HomeIcon, CompassIcon, DollarSignIcon, CoffeeIcon, FileTextIcon, PlusIcon, SaveIcon, EditIcon, XIcon } from 'lucide-react';
interface CustomerPreferencesProps {
  preferences: {
    destinations: string[];
    accommodationType: string;
    travelStyle: string;
    budget: string;
    mealPreferences: string;
    specialRequests: string;
  };
}
export const CustomerPreferences: React.FC<CustomerPreferencesProps> = ({
  preferences
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedPreferences, setEditedPreferences] = useState({
    ...preferences
  });
  const [newDestination, setNewDestination] = useState('');
  const handleSavePreferences = () => {
    // In a real app, this would save the preferences to the backend
    console.log('Saving preferences:', editedPreferences);
    setIsEditing(false);
  };
  const handleAddDestination = () => {
    if (newDestination && !editedPreferences.destinations.includes(newDestination)) {
      setEditedPreferences({
        ...editedPreferences,
        destinations: [...editedPreferences.destinations, newDestination]
      });
      setNewDestination('');
    }
  };
  const handleRemoveDestination = (destination: string) => {
    setEditedPreferences({
      ...editedPreferences,
      destinations: editedPreferences.destinations.filter(d => d !== destination)
    });
  };
  return <div className="p-6" data-id="element-1756">
      <div className="flex justify-between items-center mb-6" data-id="element-1757">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-1758">
          Travel Preferences
        </h2>
        {isEditing ? <div className="flex space-x-2" data-id="element-1759">
            <button className="flex items-center px-3 py-1.5 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" onClick={() => setIsEditing(false)} data-id="element-1760">
              <XIcon className="h-4 w-4 mr-2" data-id="element-1761" />
              Cancel
            </button>
            <button className="flex items-center px-3 py-1.5 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700" onClick={handleSavePreferences} data-id="element-1762">
              <SaveIcon className="h-4 w-4 mr-2" data-id="element-1763" />
              Save Changes
            </button>
          </div> : <button className="flex items-center px-3 py-1.5 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" onClick={() => setIsEditing(true)} data-id="element-1764">
            <EditIcon className="h-4 w-4 mr-2" data-id="element-1765" />
            Edit Preferences
          </button>}
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1766">
        {/* Destinations */}
        <div className="p-6 border-b border-gray-200" data-id="element-1767">
          <div className="flex items-center mb-4" data-id="element-1768">
            <MapPinIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-1769" />
            <h3 className="text-md font-medium text-gray-800" data-id="element-1770">
              Preferred Destinations
            </h3>
          </div>
          {isEditing ? <div data-id="element-1771">
              <div className="flex flex-wrap gap-2 mb-3" data-id="element-1772">
                {editedPreferences.destinations.map(destination => <div key={destination} className="flex items-center px-3 py-1.5 bg-blue-100 text-blue-800 rounded-full text-sm" data-id="element-1773">
                    {destination}
                    <button className="ml-2 text-blue-600 hover:text-blue-800" onClick={() => handleRemoveDestination(destination)} data-id="element-1774">
                      <XIcon className="h-3.5 w-3.5" data-id="element-1775" />
                    </button>
                  </div>)}
              </div>
              <div className="flex" data-id="element-1776">
                <input type="text" className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Add a destination..." value={newDestination} onChange={e => setNewDestination(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleAddDestination()} data-id="element-1777" />
                <button className="px-3 py-2 bg-blue-600 text-white rounded-r-md hover:bg-blue-700" onClick={handleAddDestination} data-id="element-1778">
                  <PlusIcon className="h-4 w-4" data-id="element-1779" />
                </button>
              </div>
            </div> : <div className="flex flex-wrap gap-2" data-id="element-1780">
              {preferences.destinations.map(destination => <span key={destination} className="px-3 py-1.5 bg-blue-100 text-blue-800 rounded-full text-sm" data-id="element-1781">
                  {destination}
                </span>)}
            </div>}
        </div>
        {/* Accommodation Type */}
        <div className="p-6 border-b border-gray-200" data-id="element-1782">
          <div className="flex items-center mb-4" data-id="element-1783">
            <HomeIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-1784" />
            <h3 className="text-md font-medium text-gray-800" data-id="element-1785">
              Accommodation Preferences
            </h3>
          </div>
          {isEditing ? <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={editedPreferences.accommodationType} onChange={e => setEditedPreferences({
          ...editedPreferences,
          accommodationType: e.target.value
        })} data-id="element-1786">
              <option value="Luxury" data-id="element-1787">Luxury</option>
              <option value="Boutique Hotels" data-id="element-1788">Boutique Hotels</option>
              <option value="Resort" data-id="element-1789">Resort</option>
              <option value="Mid-range" data-id="element-1790">Mid-range</option>
              <option value="Budget" data-id="element-1791">Budget</option>
              <option value="Family-friendly resorts" data-id="element-1792">
                Family-friendly resorts
              </option>
              <option value="Wellness resorts" data-id="element-1793">Wellness resorts</option>
              <option value="Eco-lodges" data-id="element-1794">Eco-lodges</option>
            </select> : <p className="text-gray-700" data-id="element-1795">{preferences.accommodationType}</p>}
        </div>
        {/* Travel Style */}
        <div className="p-6 border-b border-gray-200" data-id="element-1796">
          <div className="flex items-center mb-4" data-id="element-1797">
            <CompassIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-1798" />
            <h3 className="text-md font-medium text-gray-800" data-id="element-1799">Travel Style</h3>
          </div>
          {isEditing ? <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={editedPreferences.travelStyle} onChange={e => setEditedPreferences({
          ...editedPreferences,
          travelStyle: e.target.value
        })} data-id="element-1800">
              <option value="Cultural" data-id="element-1801">Cultural</option>
              <option value="Cultural & Historical" data-id="element-1802">
                Cultural & Historical
              </option>
              <option value="Adventure & Active" data-id="element-1803">Adventure & Active</option>
              <option value="Relaxation" data-id="element-1804">Relaxation</option>
              <option value="Family vacations" data-id="element-1805">Family vacations</option>
              <option value="Wellness & Relaxation" data-id="element-1806">
                Wellness & Relaxation
              </option>
              <option value="Luxury" data-id="element-1807">Luxury</option>
              <option value="Budget travel" data-id="element-1808">Budget travel</option>
            </select> : <p className="text-gray-700" data-id="element-1809">{preferences.travelStyle}</p>}
        </div>
        {/* Budget */}
        <div className="p-6 border-b border-gray-200" data-id="element-1810">
          <div className="flex items-center mb-4" data-id="element-1811">
            <DollarSignIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-1812" />
            <h3 className="text-md font-medium text-gray-800" data-id="element-1813">Budget Range</h3>
          </div>
          {isEditing ? <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={editedPreferences.budget} onChange={e => setEditedPreferences({
          ...editedPreferences,
          budget: e.target.value
        })} data-id="element-1814">
              <option value="Under $2000" data-id="element-1815">Under $2000</option>
              <option value="$2000-$3000" data-id="element-1816">$2000-$3000</option>
              <option value="$2000-$3500" data-id="element-1817">$2000-$3500</option>
              <option value="$2500-$4000" data-id="element-1818">$2500-$4000</option>
              <option value="$3000-$5000" data-id="element-1819">$3000-$5000</option>
              <option value="$5000-$7500" data-id="element-1820">$5000-$7500</option>
              <option value="$7500-$10000" data-id="element-1821">$7500-$10000</option>
              <option value="$10,000+" data-id="element-1822">$10,000+</option>
            </select> : <p className="text-gray-700" data-id="element-1823">{preferences.budget}</p>}
        </div>
        {/* Meal Preferences */}
        <div className="p-6 border-b border-gray-200" data-id="element-1824">
          <div className="flex items-center mb-4" data-id="element-1825">
            <CoffeeIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-1826" />
            <h3 className="text-md font-medium text-gray-800" data-id="element-1827">
              Meal Preferences
            </h3>
          </div>
          {isEditing ? <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={editedPreferences.mealPreferences} onChange={e => setEditedPreferences({
          ...editedPreferences,
          mealPreferences: e.target.value
        })} data-id="element-1828" /> : <p className="text-gray-700" data-id="element-1829">{preferences.mealPreferences}</p>}
        </div>
        {/* Special Requests */}
        <div className="p-6" data-id="element-1830">
          <div className="flex items-center mb-4" data-id="element-1831">
            <FileTextIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-1832" />
            <h3 className="text-md font-medium text-gray-800" data-id="element-1833">
              Special Requests
            </h3>
          </div>
          {isEditing ? <textarea className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" rows={3} value={editedPreferences.specialRequests} onChange={e => setEditedPreferences({
          ...editedPreferences,
          specialRequests: e.target.value
        })} data-id="element-1834" /> : <p className="text-gray-700" data-id="element-1835">{preferences.specialRequests}</p>}
        </div>
      </div>
      {/* Recommendation box */}
      <div className="mt-6 bg-blue-50 border border-blue-100 rounded-lg p-4" data-id="element-1836">
        <h3 className="text-md font-medium text-blue-800 mb-2" data-id="element-1837">
          Personalized Recommendations
        </h3>
        <p className="text-sm text-blue-700 mb-3" data-id="element-1838">
          Based on this customer's preferences, they might be interested in:
        </p>
        <div className="space-y-2" data-id="element-1839">
          {preferences.travelStyle.includes('Cultural') && <div className="flex items-start" data-id="element-1840">
              <div className="flex-shrink-0 h-8 w-8 rounded bg-blue-100 flex items-center justify-center text-blue-600 mr-2" data-id="element-1841">
                <MapPinIcon className="h-4 w-4" data-id="element-1842" />
              </div>
              <div data-id="element-1843">
                <p className="text-sm font-medium text-blue-800" data-id="element-1844">
                  Cultural Experiences
                </p>
                <p className="text-xs text-blue-700" data-id="element-1845">
                  Museum tours, local cuisine tastings, historical sites
                </p>
              </div>
            </div>}
          {preferences.accommodationType.includes('Luxury') && <div className="flex items-start" data-id="element-1846">
              <div className="flex-shrink-0 h-8 w-8 rounded bg-blue-100 flex items-center justify-center text-blue-600 mr-2" data-id="element-1847">
                <HomeIcon className="h-4 w-4" data-id="element-1848" />
              </div>
              <div data-id="element-1849">
                <p className="text-sm font-medium text-blue-800" data-id="element-1850">
                  Luxury Accommodations
                </p>
                <p className="text-xs text-blue-700" data-id="element-1851">
                  5-star hotels, private villas, exclusive resorts
                </p>
              </div>
            </div>}
          {preferences.destinations.includes('Japan') && <div className="flex items-start" data-id="element-1852">
              <div className="flex-shrink-0 h-8 w-8 rounded bg-blue-100 flex items-center justify-center text-blue-600 mr-2" data-id="element-1853">
                <CompassIcon className="h-4 w-4" data-id="element-1854" />
              </div>
              <div data-id="element-1855">
                <p className="text-sm font-medium text-blue-800" data-id="element-1856">
                  Japan Cherry Blossom Tour
                </p>
                <p className="text-xs text-blue-700" data-id="element-1857">
                  Premium spring tour package with cultural experiences
                </p>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};